import React from 'react';
import Layout from '../components/Layout';
import { FormattedMessage } from 'react-intl';
import { graphql } from 'gatsby';
import SEO from '../components/SEO/SEO';
import { getUserLangKey } from 'ptz-i18n';

const horoscopeAmp = ({ data, location, pageContext }) => {
  const { sign, horoscopesByProvider } = pageContext;
  const { langs, defaultLangKey } = data.site.siteMetadata.languages;
  const langKey = getUserLangKey(langs, defaultLangKey);

  const jsonData = { type: 'horoscope', slug: pageContext.slug };
  const pageDate = new Date(pageContext.date);

  return (
    <Layout className="container" data={data} jsonData={jsonData} location={location}>
      <SEO
        horoscopeData={{ pageDate, sign }}
        frontmatter={{ slug: `${langKey}/${pageContext.slug.toLowerCase()}` }}
        postImage={`/img/signs-png/${sign.toLowerCase()}.png`}
      />
      <div className="container content">
        <div className="columns is-centered">
          <figure class="image is-128x128">
            <img className="image" src={`/img/signs/${pageContext.sign.toLowerCase()}.svg`} />
            <figcaption>
              <h1>
                <FormattedMessage id={`signs.${sign.toLowerCase()}`} />
              </h1>
            </figcaption>
          </figure>
        </div>
        <br />
        {horoscopesByProvider.map(provider => (
          <>
            <h3 className="title animated bounceInLeft">{provider.providerName}</h3>
            <div>{provider.providerHoroscope?.daily}</div>
          </>
        ))}
      </div>
    </Layout>
  );
};

export default horoscopeAmp;

export const pageQuery = graphql`
  query HoroscopeAmpQuery {
    site {
      siteMetadata {
        title
        languages {
          langs
          defaultLangKey
        }
      }
    }
  }
`;
